export const getCampaignState = (state) => {
  return state.campaignSP.campaignList
};
